/*
 * @Description: 路由
 * @Date: 2025-07-23 15:37:44
 */
export const route = [
  {
    path: '/download-progress-list',
    name: 'download-progress-list',
    meta: {
      title: '文件下载进度'
    },
    component: () => import('../views/download-progress-list.vue')
  }
];
